import { Create, useForm } from '@refinedev/antd';
import type { HttpError } from '@refinedev/core';
import { message } from 'antd';
import { useState } from 'react';

import { FailReport } from '@/model/FailReport/FailReport';
import { FailReportItem } from '@/model/FailReport/FailReportItem';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

import FailReportForm from './FailReportForm/FailReportForm';

export const FailReportCreate = () => {
  const { failReportRepository } = useRepositoriesContext();
  const [failReportItems, setFailReportItems] = useState<FailReportItem[]>([]);
  const { formProps, saveButtonProps } = useForm<FailReport, HttpError, FailReport>({
    successNotification: {
      message: 'Informe de falla creado correctamente',
      type: 'success',
    },
    onMutationSuccess(failReportResponse) {
      if (failReportResponse.data.id) {
        void failReportRepository
          .saveFailReportItems(failReportItems, failReportResponse.data.id)
          .catch(error => {
            message.error('Ocurrió un error al guardar los items del informe de falla.');
            console.error('Error saving fail report items:', error);
          });
      }
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <FailReportForm
        formProps={formProps}
        failReportItems={failReportItems}
        setFailReportItems={setFailReportItems}
      />
    </Create>
  );
};
